import styles from '@features/navigation/components/MegaMenuDesktop/MegaMenuDesktop.styles';
import MarketingProductsType from '@features/navigation/components/MarketingProductsType/MarketingProductsType';
import { ICategory } from '@features/categories';
import ExtraButtons from '@features/navigation/components/ExtraButtons/ExtraButtons';
type PropsType = {
  product: ICategory;
  onSelectProduct: (product: ICategory | null) => void;
  isVisible: boolean;
  onClose?: () => void | null;
};
const MarketingProducts = ({
  product,
  onSelectProduct,
  isVisible,
  onClose = undefined
}: PropsType) => <div sx={styles.marketingProducts(isVisible)}>
    <ExtraButtons product={product} onClose={onClose} />
    <MarketingProductsType marketingList={product.children} onSelectType={onSelectProduct} onClose={onClose} />
  </div>;
export default MarketingProducts;